import axios from 'axios';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}


export default {
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/budgetproduksi/detail/${obj.pjxhdrkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    ibbooked(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/budgetproduksi/ibbooked/${obj.pjxhdrkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'createby', 'uraian', 'nomor', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'customer', 'cust_po', 'status', 'jmlproduksi'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                // if (obj.customQuery) {
                //     str += str ? '&' : '?';
                //     str += obj.customQuery;
                // }
                const url = `/budgetproduksi${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    approval(formData) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log('File Name : ', formData.filename);
                const { data } = await axios.post("budgetproduksi/send2wf", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approvalUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`/budgetproduksi/send2wfCancel/${obj.pjxhdrkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    progress(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/budgetproduksi/progress/${obj.pjxhdrkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    progressprint(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                if (obj.pjxhdrkey) {
                    const url = `/budgetproduksi/progressprint/${obj.pjxhdrkey}`;
                    const { data } = await axios.get(url);
                    const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                    resolve(link);
                }

            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    progressdtl(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/budgetproduksi/progressdtl/${obj.pjxbudgkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    print(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                if (obj.pjxhdrkey) {
                    const url = `/budgetproduksi/print/${obj.pjxhdrkey}`;
                    const { data } = await axios.get(url);
                    const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                    resolve(link);
                }

            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    printOriginalApprovedBefore(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                if (obj.pjxhdrkey) {
                    const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf-approved/${obj.pjxhdrkey}`
                    resolve(link);
                }

            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxls(obj = {}) {
        const keys = ['sortBy', 'sortDir', 'uraian', 'nomor', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'customer', 'cust_po', 'status'];
        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/budgetproduksi/exportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'budgetlist.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // const resp = await axios.post(`/budgetproduksi`, obj);
                // resolve(resp);
                const { data } = await axios.post("budgetproduksi", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    saveDimension(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // const resp = await axios.post(`/budgetproduksi`, obj);
                // resolve(resp);
                const { data } = await axios.post("budgetproduksi/save-dimension", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    updateJmlProduksi(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.put("/budgetproduksi/update-jumlah-produksi", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/budgetproduksi/${obj.pjxhdrkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },

    lastEps(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['DimCol', 'DimColInfo', 'DimVal'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const { data } = await axios.get(`budgetproduksi/lastepisode${str}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    layout(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // const { data } = await axios.get(`budgetdept/layout/${encodeURIComponent(obj.layout)}`);
                const { data } = await axios.get(`budgetprodfmt/${encodeURIComponent(obj.layout)}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    layout_combo() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`budgetprodfmt/combo`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    layoutDel(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`budgetprodfmt/${encodeURIComponent(obj.layout)}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    layoutSave(data) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post("budgetprodfmt", data);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }

};